module.exports = __webpack_public_path__ + "static/media/synonyms sample data.72e39dc1.csv";